<xi-drawer
  *transloco="let t; read: 'dashboard-options-component'"
  [open]="open"
  [interceptClose]="true"
  (onClose)="cancel()"
  color="CX"
  [silverBg]="true"
>
  <div slot="title">{{ t('dashboard-options') }}</div>

  <div slot="body">
    <xi-horizontal-tab-bar
      [data]="tabs"
      [(activeTabId)]="activeTabId"
      [hasTransparentBackground]="true"
      [stretch]="true"
      [tabSpacing]="25"
      color="CX"
    >
    </xi-horizontal-tab-bar>

    @switch (activeTabId) {
      @case ('general') {
        <app-dashboard-option-general
          [dashboardOriginal]="dashboard"
          [dashboard]="dashboardCopy"
          (dashboardChanged)="onDashboardChanged($event)"
          (clearUserCache)="clearUserCache.emit()"
          [(isValid)]="isValid"
          [isReadOnly]="isReadOnly"
        ></app-dashboard-option-general>
      }
      @case ('save-export') {
        <app-dashboard-option-save-and-export
          [dashboard]="dashboard"
          (saveAsDashboard)="saveAsDashboard.emit()"
          (exportDashboard)="exportDashboard.emit()"
          [isReadOnly]="isReadOnly"
        ></app-dashboard-option-save-and-export>
      }
      @case ('permissions') {
        <app-dashboard-option-permissions
          [dashboardOriginal]="dashboard"
          [dashboard]="dashboardCopy"
          (dashboardChanged)="onDashboardChanged($event)"
          [isReadOnly]="isReadOnly"
          [isHideVisible]="isHideVisible"
          [exposedSave]="exposedSave"
        ></app-dashboard-option-permissions>
      }
      @case ('metadata') {
        <app-dashboard-option-metadata [dashboard]="dashboard"></app-dashboard-option-metadata>
      }
      @case ('history') {
        <app-dashboard-option-history
          [dashboard]="dashboard"
          [session]="session"
          (restoreDashboard)="restoreDashboard.emit($event)"
        ></app-dashboard-option-history>
      }
    }
  </div>

  <div slot="footer" [class.show-footer]="isDashboardChanged || isSaving">
    <xi-default-button
      text="{{ t('cancel') }}"
      fill="text"
      [disabled]="isSaving"
      (onClick)="cancel()"
    ></xi-default-button>

    <div class="xi-loader-button-container">
      <xi-default-button
        text="{{ t('save') }}"
        [disabled]="!isValid"
        (onClick)="save()"
      ></xi-default-button>

      @if (isSaving) {
        <div class="xi-loader-container__inline-overlay">
          <xi-animation
            [height]="75"
            [width]="75"
            [loop]="true"
            animation="cx_loader"
          ></xi-animation>
        </div>
      }
    </div>
  </div>
</xi-drawer>
